/**
 * Created by hp on 2017/7/4.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dialog} from 'react-weui';

class ImgTipsDialog extends Component {
    constructor() {
        super();
        this.handleRequestClose = this.handleRequestClose.bind(this);
        this.state = {
            dialogStyle: {
                buttons: [{
                    label: '知道了',
                    onClick: this.handleRequestClose
                }]
            }
        }
    }

    handleRequestClose() {
        const {callback} = this.props.imgTipsDialog;
        this.props.dispatch({
            type: 'COMPONENT_INIT_IMGTIPS_DIALOG',
            payload: {
                showTipsDialog: false
            }
        });
        if (callback) {
            callback();
        }
    }

    render() {
        const {title, img, msg, showTipsDialog} = this.props.imgTipsDialog;
        const {dialogStyle} = this.state;
        return (
            <div className="img-tips-dialog">
                <Dialog title={title} type="ios" buttons={dialogStyle.buttons} show={showTipsDialog}>
                    <p className="tips-img"><img alt="" src={img}/></p>
                    <p className="tips-text">{msg}</p>
                </Dialog>
            </div>
        )
    }
}

export default connect((state) => ({
    imgTipsDialog: state.component.imgTipsDialog
}))(ImgTipsDialog)



// WEBPACK FOOTER //
// ./src/components/ImgTipsDialog.js